<template>
    <div
        class="sbs-spinner"
        :class="spinnerClasses">
        <svg
            class="sbs-spinner__icon"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M30 55C43.8071 55 55 43.8071 55 30C55 16.1929 43.8071 5 30 5C17.0354 5 6.37578 14.8685 5.12309 27.5035C4.98687 28.8775 3.88071 30 2.5 30C1.11929 30 -0.0108639 28.8768 0.102622 27.5008C1.37264 12.1016 14.2731 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C26.4077 60 22.9628 59.3686 19.7704 58.2107C18.2574 57.662 17.8138 55.8043 18.786 54.5216C19.4982 53.5819 20.7572 53.266 21.8723 53.6491C24.4205 54.5247 27.1547 55 30 55Z"
                :fill="`url(#${uniqueIds[0]})`" />
            <path
                d="M30 55C43.8071 55 55 43.8071 55 30C55 16.1929 43.8071 5 30 5C17.0354 5 6.37578 14.8685 5.12309 27.5035C4.98687 28.8775 3.88071 30 2.5 30C1.11929 30 -0.0108639 28.8768 0.102622 27.5008C1.37264 12.1016 14.2731 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C26.4077 60 22.9628 59.3686 19.7704 58.2107C18.2574 57.662 17.8138 55.8043 18.786 54.5216C19.4982 53.5819 20.7572 53.266 21.8723 53.6491C24.4205 54.5247 27.1547 55 30 55Z"
                :fill="`url(#${uniqueIds[1]})`" />
            <defs>
                <radialGradient
                    :id="uniqueIds[0]"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(30 13.5) rotate(124.261) scale(41.7433 41.9225)">
                    <stop stop-color="currentColor" />
                    <stop
                        offset="1"
                        stop-color="currentColor"
                        stop-opacity="0" />
                </radialGradient>
                <radialGradient
                    :id="uniqueIds[1]"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(30 13.5) rotate(120.75) scale(45.9619 46.1594)">
                    <stop stop-color="currentColor" />
                    <stop
                        offset="1"
                        stop-color="currentColor"
                        stop-opacity="0" />
                </radialGradient>
            </defs>
        </svg>
        <slot>
            <div
                class="sbs-spinner__content"
                :class="spinnerContentClass">
                {{ content }}
            </div>
        </slot>
    </div>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { isArrayContainsValue } from '../../utils/validators.js';
import { getRandomId } from '../../utils/helpers.js';
import {
    AllSizes,
    SPINNER_SIZES,
} from '../../utils/sizes.js';

const ICONS_URL_IDS_NUMBER = 2;

/**
 * Базовый компонент-спиннер, предназначенный для лоадера
 */
export default {
    name: 'SbsSpinner',
    mixins: [themesMixin],
    computed: {
        spinnerClasses() {
            const classes = [this.size];

            if (this.reverse) classes.push('sbs-spinner--reverse');

            return [
                ...classes,
                ...this.themeClasses,
            ];
        },
        uniqueIds() {
            return new Array(ICONS_URL_IDS_NUMBER)
                .fill('')
                .map(getRandomId);
        },
    },
    props: {
        /**
         * Текстовый контент
         */
        content: {
            type: [Number, String],
            default: '',
        },
        /**
         * Устанавливает анимацию для спиннера в одну сторону и в обратную сторону
         */
        reverse: {
            type: Boolean,
            default: false,
        },
        /**
         * Устанавливает размер спиннера (на выбор `small`, `medium` или `large`)
         */
        size: {
            type: String,
            default: AllSizes.SMALL,
            validator: isArrayContainsValue(SPINNER_SIZES),
        },
        /**
         * Класс для контента внутри спиннера
         */
        spinnerContentClass: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.sbs-spinner {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    &.small {
        width: 30px;
        height: 30px;
    }

    &.medium {
        width: 48px;
        height: 48px;
    }

    &.large {
        width: 60px;
        height: 60px;
    }

    &__icon {
        width: 100%;
        height: 100%;
        animation: 1s linear infinite spinner;

        .sbs-spinner--reverse & {
            animation-name: spinner-reverse;
        }
    }

    &__content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
